var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('stock-movement-form',{attrs:{"loading":_vm.loading,"stockMovementData":_vm.stockMovement,"formErrors":_vm.formErrors},on:{"stockMovementSubmitted":_vm.handleSubmit,"formChanged":() => (_vm.alertLeave = true)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }